import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { apiConnector } from "../../../services/apiconnector";
import { bookEndpoints } from "../../../services/apis";
import { fetchBokCategories } from "../../../services/operations/bookDetais";
import { useSelector } from "react-redux";
import { getCatalogPageData } from "../../../services/operations/bookDetais";
import { FaSearch } from "react-icons/fa";

function AllBook() {
  const { GET_ALL_BOOK_API } = bookEndpoints;
  const [loading, setLoading] = useState(false);
  const [book, setBook] = useState([]); // all books
  const [courseCategories, setCourseCategories] = useState([]); // all categories
  const [selectedCategory, setSelectedCategory] = useState("all"); // selected category by student
  const [filteredBooks, setFilteredBooks] = useState([]); // filtered books
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchBook = async (page) => {
    // const toastId = toast.loading("Loading...");
    setLoading(true);
    try {
      const response = await apiConnector("GET", `${GET_ALL_BOOK_API}?page=${page}&limit=10`);
      if (!response?.data?.success) {
        throw new Error("Could Not Fetch Books Categories");
      }

      setBook(response.data?.data);
      setFilteredBooks(response.data?.data);
      setTotalPages(response.data?.pagination.totalPages);
    } catch (error) {
      console.log("GET_ALL_BOOK_API API ERROR............", error);
      toast.error(error.message);
    }
    setLoading(false);
    // toast.success("Fetched Book");
    // toast.dismiss(toastId);
  };

  const getCategories = async () => {
    setLoading(true);
    const categories = await fetchBokCategories();

    if (categories.length > 0) {
      setCourseCategories(categories);
    }
    setLoading(false);
  };

  const handleCategoryChange = (e) => {
    e.preventDefault();
    const selectedValue = e.target.value;
    setSelectedCategory(selectedValue);

    if (selectedValue === "all") {
      setFilteredBooks(book); // Display all books when 'All' category is selected
    } else {
      const filtered = book.filter(
        (book) => book.category._id === selectedValue
      );
      setFilteredBooks(filtered);
    }
  };

  const handleSearch = (e) => {
    const searchText = e.target.value.toLowerCase();
    const filteredBySearch = book.filter(
      (item) =>
        (item.bookName || "").toLowerCase().includes(searchText) ||
        ((item.bookID || "") + "").toLowerCase().includes(searchText) ||
        ((item.edition || "") + "").toLowerCase().includes(searchText) ||
        ((item.authorName || "") + "").toLowerCase().includes(searchText)
    );
    setFilteredBooks(filteredBySearch);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(()=>{
    getCategories();

  },[])
  useEffect(() => {
  
    fetchBook(currentPage);
  }, [currentPage]);

  return (
    <div>
      <div className="flex flex-col lg:gap-10 gap-3 justify-center ">
        <h1 className="font-bold font-mulish text-2xl"> Library All Books </h1>

    

        <div className="flex gap-20 text-xl w-full">
          <div className="flex flex-wrap gap-10 bg-richblack-5 w-full justify-around p-2 rounded-2xl">
            <div className="flex flex-col space-y-2 lg:lg:w-[400px]  w-full md:w-[230px]">
              <div className="flex flex-col lg:flex-row space-y-2 lg:lg:w-[400px]  w-full md:w-[230px] lg:items-center lg:gap-2">
                <FaSearch className="lg:text-2xl hidden lg:block " />

                <input
                  type="text"
                  className="shadow-black  bg-blue-100 rounded-3xl p-2 text-black placeholder:text-black"
                  onChange={handleSearch}
                  placeholder="Search"
                />
              </div>
            </div>

            <div className="flex flex-col space-y-2 lg:lg:w-[400px]  w-full md:w-[230px]">
              <select
                defaultValue=""
                id="category"
                className="form-style w-full"
                onChange={handleCategoryChange}
              >
                <option value="all">All</option>
                {!loading &&
                  courseCategories?.map((category) => (
                    <option key={category?._id} value={category?._id}>
                      {category.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>

        <div className='flex justify-end '>
        <button
          className={`bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-l ${currentPage === 1 ? " opacity-0": ""}`}
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span className='bg-gray-300 text-gray-800 font-bold py-2 px-4'>
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={` bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-r ${currentPage === totalPages ? " opacity-0": ""}`}
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next 

        </button>
      </div>
      
      {loading ? (
        <div className="grid  place-items-center">
          <div className="spinner"></div>
        </div>
) : (
  <div className='overflow-x-auto'>
      <table className='min-w-full'>
        <thead>
          <tr>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              Book Name
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
            Book ID
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
            Book Author
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
            Book Edition
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
            Book Publisher
            </th>
            <th className='px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
            Book Category
            </th>
            
          </tr>
        </thead>
        <tbody className='bg-white divide-y divide-gray-200'>
          {filteredBooks.map((one) => (
         
              <tr key={one._id}>
                <td className='px-6 py-4 whitespace-nowrap'>{one?.bookName}</td>
                <td className='px-6 py-4 whitespace-nowrap'>         {one?.bookID}       </td>
                <td className='px-6 py-4 whitespace-nowrap'>          {one?.authorName}           </td>
                <td className='px-6 py-4 whitespace-nowrap'>{one?.edition}</td>
                <td className='px-6 py-4 whitespace-nowrap'>{one?.bookPublisherName}</td>
                <td className='px-6 py-4 whitespace-nowrap'>{one?.category?.name}</td>
              </tr>
          
          ))}
        </tbody>
      </table>
    </div>
)}

      </div>
    </div>
  );
}

export default AllBook;
